import { Injectable } from '@angular/core';
import {AuthHttp} from '../core/auth-http.service';
import {Observable} from 'rxjs/Observable';
import {SimpleTravel} from './product.types';
import {Http, Headers, Request, RequestMethod, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';

import 'rxjs/add/operator/map';
import {Subject} from 'rxjs/Subject';
import {ReplaySubject} from 'rxjs/ReplaySubject';

import {environment} from '../../environments/environment';
import { BasicTravel } from './basic.travel';


@Injectable()
export class SimpleTravelService {

    // private headers = new Headers({'Content-Type': 'application/json'});

    constructor(private http: AuthHttp, private httppp: Http) {
    }

    getImageUrl(tenantCode, uploadId: number): string {
        return environment.apiBaseUrl + 'dms/public/' + tenantCode + '/' + uploadId;
    }

    getSimpleTravel(id: number): Observable<SimpleTravel> {
        return this.http.get('prd/travel/admin/' + id)
            .map(response => response.json())
    }

    getSimpleTravels(): Observable<SimpleTravel[]> {
        return this.http.get('prd/travel/admin')
            .map(response => response.json());
    }

    // TODO replace this by single methods in app/core/static.service.ts and delete this function?
    // TODO replace airports by getAirportsBySuperRegion in app/core/static.service.ts
    getStaticData() {
        return this.http.get('basic/static/roomTypes,superRegions,fromAirports,boardTypes')
            .map(response => response.json())
    }

    // TODO replace this by method getRegionsBySuperRegion in app/core/static.service.ts and delete this function?
    getSuperRegions(superRegion) {
        return this.http.get('basic/regions/' + superRegion + '/name')
            .map(response => response.json())
    }

    // TODO replace this by method getAirportsBySuperRegion in app/core/static.service.ts and delete this function?
    getAirportsForRegion(superRegion) {
        return this.http.get('basic/airports/' + superRegion + '/name')
            .map(response => response.json())
    }

    // save simple travel: cvoro
    saveSimpleTravel(travel: SimpleTravel) {
        let response: Observable<Response>;
        response = this.http.post('prd/travel/admin', travel)

        return response
            .map(res => res.json());
    }

    copySimpleTravel(travel: SimpleTravel) {
        let response: Observable<Response>;
        response = this.http.post('prd/travel/admin', travel)

        return response
            .map(res => res.json());
    }

    // delete of simple travel: cvoro
    deleteSimpleTravel(travel: SimpleTravel) {
        let response: Observable<Response>;
        response = this.http.delete('prd/travel/admin/' + travel.id);

        return response
            .map(res => res.json());
    }

    loadImagesForTravel(id) {
      let response: Observable<Response>;
      response = this.http.get('dms/load/' + id)

      return response
          .map(res => res.json());
    }

    getSpecifisAaignment(id) {
      let response: Observable<Response>;
      response = this.http.get('dms/assignment/admin/' + id)

      return response
          .map(res => res.json());
    }

  public changeAssignmentOfImage(assignment) {
    let response: Observable<Response>;
    response = this.http.put('dms/assignment/admin/' + assignment.id, assignment)

    return response
        .map(res => res.json());
}

  public deleteAssignment(assignment) {
    let response: Observable<Response>;
    response = this.http.delete('dms/assignment/admin/' + assignment)

    return response
        .map(res => res.json());
  }

  // /dms/assignment/admin[/:id]


    public uploadFile(file, base64, file_name, id, isMain) {
      let response: Observable<Response>;

      // TODO - change 'seq' to null when Falk finish CMS-306
        let meta = {
          'storage': 2,
          'lang': 'de_DE',
          'display': file_name,
          'public': true,
          'locked': false,
          'table': 'prd_product',
          'foreign': id,
          'seq': 1,
          'main': isMain
         }
         let send = JSON.stringify(meta)
        var body = `--blob
Content-Disposition: form-data; name="postData"; filename="${file_name}"
Content-Type: ${file.type}

${base64}
--blob
Content-Disposition: form-data; name="Json"
Content-Type: application/json

${send}
--blob--`;

        // console.log(body);

        // response = this.http.post('dms/file', file)
        response = this.httppp.post(environment.apiBaseUrl + 'dms/file', body, this.headers())

        return response
            .map(res => res.json())
    }

    private headers() {
        let id_token = 'i2pn0pklng6l98cinds07cfo02';
        let headers = new Headers({'Bonanza-Session-Id': id_token});
        // headers.append('Content-Type', 'application/json')
        headers.append('Content-Type', 'multipart/form-data; boundary=blob')
        return new RequestOptions({headers: headers});
    }

    getSimpleTravelSkeleton(): SimpleTravel {
        return {
            id: null,
            offer: null,
            code: '',
            at: null,
            active: true,
            supplier: null,
            name: null,
            type: 'package',
            typeShort: '',
            typeName: '',
            order: '',
            durType: '',
            durTypeName: '',
            durVal: 7,
            desc: '',
            firstStart: '',
            firstEnd: '',
            fromPrice: null,
            tags: [],
            flight: {
                id: null,
                toAirport: '',
                fromAirports: []
            },
            accommodation: {
                id: null,
                name: '',
                type: '',
                category: null,
                location: '',
                region: '',
                superRegion: '',
                country: '',
                boardType: '',
                boardUpgrades: [],
                roomTypes: []
            },
            header: {
            },
            subHeader: {
            },
            subText1: {
            },
            subText2: {
            },
            shortText: {
            },
            longText: {
            },
            dataClassName: '',
            homepageType: '',
            files: []
        };
    }


    // basic travel functions
    basicSimpleTravel(travel: BasicTravel) {
      let response: Observable<Response>;
      response = this.http.post('prd/travel/admin', travel)

      return response
          .map(res => res.json());
    }

    getBasicTravels() {
      return this.http.get('prd/travel/admin')
          .map(response => response.json());
    }

    deleteBasicTravel(travel) {
      let response: Observable<Response>;
      response = this.http.delete('prd/travel/admin/' + travel.id);

      return response
          .map(res => res.json());
    }

    getBasicTravel(id: number) {
      return this.http.get('prd/travel/admin/' + id)
          .map(response => response.json())
    }
}




// WEBPACK FOOTER //
// ./src/app/product/simple-travel.service.ts